module.exports = __webpack_public_path__ + "static/hackathon-kickoff-77e68aa4e8c1f7fb28dda2240d240531.jpg";